// removed by extract-text-webpack-plugin
module.exports = {"pagechildren":"_2Uy5QHaVBioL9PzX2VBvPR","childa":"zSPf3JYLZi0brVYreGvg4","status":"_CRlGz5JMjMHJc8YDyhGF","evaluate":"_383E6CqdgayT50fYjYSOG4","childb":"_3zx9b6IrIM5T_yQICTF0","pagelienew":"_26ooC3R39d3oTRJ7-xRvIo","lienewtop":"i8YCymk27NE-XaPegEtnP","newtoptxt":"_2n2aK1oneJ8tBnaZgPlffW"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GroupBuyingOrderListComponent/GroupBuyingOrderListComponent.scss
 ** module id = 978
 ** module chunks = 0
 **/